export default function normalizeQuotes(string) {
  return string.replace('‘', "'").replace('’', "'").replace('“', '"').replace('”', '"');
}